import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="About" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        This is a networks themed version of the game Wordle.{' '}
        It was developed as a tool for teaching about networks. {' '}
        All words are network-related in some way. {' '}
        This code is a slight modification from the Wordle clone created by Hannah Park- {' '}
        <a
          href="https://github.com/hannahcode/wordle"
          className="underline font-bold"
        >
          check out their code here
        </a>{' '}
        or{' '}
        <a
          href="https://www.powerlanguage.co.uk/wordle/"
          className="underline font-bold"
        >
          play the original Wordle, created by Josh Wardle, here.
        </a>
        About Me:{' '}
        I am{'  '} 
        <a
          href="https://sonic.northwestern.edu/home/people/graduate-student-researchers/brennan-antone/"
          className="underline font-bold"
        >Brennan Antone
        </a>{' '}
        , a PhD candidate at Northwestern University studying social networks in teams and network interventions. I'm currently on the job market, if you are hiring.
      </p>
    </BaseModal>
  )
}
